/*
 * IBM Confidential
 * OCO Source Materials
 * IBM Business Platform: Collaboration
 * (C) Copyright IBM Corp. 2017, 2024
 * The source code for this program is not published or otherwise divested of its trade secrets,
 * irrespective of what has been deposited with the U.S. Copyright Office
 */

define('collaboration/nls/root/CollaborationResources',{
  "add": "Add",
  "annotate_thumbnail": "Add comments to live reports and saved report output versions",
  "asset_type_dashboard": "dashboard",
  "asset_type_workspace": "workspace",
  "asset_type_data": "data module",
  "asset_type_dataset": "dataset",
  "asset_type_explore": "exploration",
  "asset_type_folder": "folder",
  "asset_type_notebook": "notebook",
  "asset_type_package": "package",
  "asset_type_report": "report",
  "asset_type_story": "story",
  "asset_type_uploadedFile": "uploaded file",
  "burst_key": "Burst Key",
  "button_add": "Add",
  "button_cancel": "Cancel",
  "button_close": "Close",
  "button_export": "Export",
  "button_next": "Next",
  "button_send": "Send",
  "button_share": "Share",
  "ca_image_short": "Image of %{assetType}",
  "ca_image": "Image of %{assetType} \"%{assetTitle}\"",
  "ca_link_short": "Open %{assetType}",
  "ca_link": "Open %{assetType} \"%{assetTitle}\"",
  "cardless_exploration": "Exploration \"%{title}\"",
  "channel_placeholder": "Channel name",
  "channel_validation_empty": "Channel field is mandatory.",
  "channel_validation_invalid": "The channel was not found.",
  "channel": "Channel",
  "click_to_annotate": "Click the image to annotate",
  "color_black": "Black",
  "color_blue": "Blue",
  "color_green": "Green",
  "color_none": "Transparent",
  "color_red": "Red",
  "color_white": "White",
  "color_yellow": "Yellow",
  "composite_provider_name": "%{providerLabel}.%{workspaceLabel}",
  "csv": "CSV",
  "email_subject_dashboard": "Dashboard \"%{assetTitle}\"",
  "email_subject_data": "Data module \"%{assetTitle}\"",
  "email_subject_dataset": "Dataset \"%{assetTitle}\"",
  "email_subject_explore": "Exploration \"%{assetTitle}\"",
  "email_subject_folder": "Folder \"%{assetTitle}\"",
  "email_subject_notebook": "Notebook \"%{assetTitle}\"",
  "email_subject_report": "Report \"%{assetTitle}\"",
  "email_subject_story": "Story \"%{assetTitle}\"",
  "email_subject_uploadedFile": "Uploaded file \"%{assetTitle}\"",
  "error_auth_cancelled": "Authentication cancelled.",
  "error_auth_failure_generic": "Failed while trying to authenticate.",
  "error_auth_failure": "Authentication failure: %{error}",
  "error_bad_client_secret": "Invalid client secret.",
  "error_cant_join": "Failed to join selected users. Make sure that the slackbot user is not selected.",
  "error_certificate_invalid": "Invalid SSL certificate.",
  "error_message_to_recipient": "Failed to send a message to %{recipientName}.",
  "error_channel_not_found": "The channel was not found or invalid.",
  "error_invalid_channel": "Invalid channel name.",
  "error_invalid_configuration": "Invalid configuration. Please contact your administrator.",
  "error_invalid_connection": "This connection is invalid. Please contact your administrator.",
  "error_invalid": "Errors found in message.",
  "error_is_archived": "Channel has been archived.",
  "error_missing_channel_id": "Missing channel Id.",
  "error_missing_message": "Missing message text or link.",
  "error_missing_recipient": "Missing recipients.",
  "error_missing_team_id": "Missing team Id.",
  "error_msg_too_long": "Message text is too long.",
  "error_no_screenshot": "Unable to capture a screenshot.",
  "error_not_enough_users": "Not enough users for a group chat. Make sure that at least two users different from yourself are selected.",
  "error_not_implemented": "Not implemented.",
  "error_not_in_channel": "Cannot post a message to a channel that the user is not a member of.",
  "error_platform_config": "Failed to get platform configuration.",
  "error_platform_not_found": "Collaboration platform is not available.",
  "error_popup_window": "It looks like pop-up windows are blocked. Change your browser settings to allow pop-ups.",
  "error_retrieving_platforms": "There was an error retrieving the list of collaboration platforms. Please contact your administrator.",
  "error_screenshot_unsupported": "This messaging platform does not support images.",
  "error_server_internal": "Internal server error.",
  "error_service_down": "Service is currently unavailable. Please try again later.",
  "error_slack_timeout": "Your message could not be shared because the server is down.",
  "error_slack": "Slack error: %{error}",
  "error_unknown": "Unknown error: %{error}",
  "error_workspace_not_found": "Failed to connect to the workspace.",
  "fit_to_page": "Fit to page",
  "format": "Format",
  "html": "HTML",
  "image": "Image",
  "label_embed_code": "Embed code:",
  "label_export_to_pdf": "Export to PDF",
  "label_height": "Height:",
  "label_include_filter": "Include filters",
  "label_link": "Link:",
  "label_no_display_name": "no display name",
  "label_orientation": "Orientation",
  "label_page_size": "Page size",
  "label_platform_error": "(%{error})",
  "label_platform": "%{platform} - %{name}",
  "label_select_platform": "Select a platform",
  "label_share_with_email": "Share with email",
  "label_share_with_msteams": "Share with Microsoft Teams: %{workspace}",
  "label_share_with_slack_single": "Share with Slack: %{workspace}",
  "label_share": "Share",
  "label_view_documentation": "click here",
  "label_warning": "Warning",
  "label_width": "Width:",
  "label_workspace": "Workspace",
  "label_you": "(you)",
  "language": "Language",
  "link_attach_report": "Attach a report",
  "link_cancel": "Cancel",
  "link_done": "Done",
  "link_email": "Email",
  "link_msteams": "Microsoft Teams",
  "link_my_content_warning": "You are sharing an asset that is located in the My content folder. Your recipient will not be able to see the asset.",
  "link_reset": "Reset",
  "link_slack": "Slack",
  "load_outputs_error": "Failed to load saved outputs.",
  "load_versions_error": "Failed to load saved versions.",
  "message_contact_administrator": "Please contact your administrator.",
  "message_empty_link": "You must save this asset before you can include a link to it.",
  "message_placeholder": "Your message goes here...",
  "message_validation_mandatory": "Message field is mandatory.",
  "message_view_documentation": "If you are using a Windows operating system, ensure that you installed a PDF driver. For more information about exporting to PDF, %{link}.",
  "message": "Message",
  "modify_your_image_optionally": "Modify your image",
  "no_outputs_available": "No saved outputs are available.",
  "no_versions_available": "No saved versions are available.",
  "orientation_landscape": "Landscape",
  "orientation_portrait": "Portrait",
  "pagesize_a4": "A4",
  "pagesize_legal": "Legal",
  "pagesize_letter": "Letter",
  "pagesize_tabloid": "Tabloid",
  "pdf": "PDF",
  "pick_output_flyout_content": "Select a version. Select a burst key, if available. Then select a format/language combination. Click Add to attach the selected output. Repeat as required.",
  "pick_output_flyout_link": "Learn more about %{topicName}.",
  "pick_output_flyout_note": "Note: Saved HTML outputs cannot be attached to an email.",
  "pick_output_flyout_title": "Attach saved output",
  "pick_output_flyout_topicName": "Sharing existing report outputs",
  "pick_report_output": "Pick report output",
  "platform_configure_message": "No collaboration platforms have been configured. Please contact your administrator.",
  "product": "IBM Cognos Analytics",
  "recipient_placeholder": "Name or channel",
  "maximum_teams_recipients": "Up to 10 recipients",
  "hint_recipients": "Selected %{numsOfRecipients}/%{maxRecipients} recipients",
  "recipient_validation_incorrect": "You can share a message either with one valid channel, yourself or with one or more valid users.",
  "recipient_validation_mandatory": "Recipient field is mandatory.",
  "recipient_validation_not_found": "No recipients found.",
  "recipient_validation_slackbot_cant_join": "The slackbot can't join a group chat.",
  "recipient_validation_too_many_recipients": "There are too many recipients. The maximum number of recipients that are allowed at one time is %{maxRecipients}.",
  "recipient": "Recipient",
  "remove_attachment": "Remove attachment",
  "select_burst_key": "Select burst key",
  "select_an_asset": "Select an asset",
  "select": "Select",
  "spreadsheetML": "Excel",
  "subview_title_explore": "Card \"%{cardTitle}\"",
  "subview_title_scene": "Scene \"%{sceneTitle}\"",
  "subview_title_tab": "Tab \"%{tabName}\"",
  "tab_export": "Export",
  "tab_link": "Link",
  "tab_send": "Send",
  "team_placeholder": "Team name",
  "team_validation_empty": "Team field is mandatory.",
  "team_validation_invalid": "The team was not found.",
  "team_validation_missing_channels": "Failed to load the team channels.",
  "team": "Team",
  "textbox_placeholder": "Enter your text here.",
  "title_no_platforms": "You don’t have any platforms yet",
  "title_not_saved": "Your asset is not saved",
  "toast_failure_detailed_email": "An error occurred while sending email: %{error} %{contactAdmin}",
  "toast_failure_detailed": "Cannot share message on %{connector}: %{error} %{contactAdmin}",
  "toast_failure_email": "An error occurred while sending email: %{error}",
  "toast_failure": "Cannot share message on %{connector}: %{error}",
  "toast_success_email": "Message sent.",
  "toast_success": "You have succesfully shared on %{connector}.",
  "toggle_include_image": "Include image",
  "toggle_include_link": "Include link",
  "toggle_include_report_output": "Include current output as an attachment",
  "tool_arrow": "Arrow",
  "tool_border": "Border",
  "tool_crop": "Crop",
  "tool_delete": "Delete",
  "tool_fill": "Fill",
  "tool_pen": "Pen",
  "tool_rect": "Rectangle",
  "tool_redo": "Redo",
  "tool_textbox": "Textbox",
  "tool_undo": "Undo",
  "unsaved_work_message": "Save your changes to ensure recipients get the latest update.",
  "version": "Version",
  "xlsxData": "Excel Data",
  "xml": "XML",
  "zoom_info": "Zoom level does not affect the shared output."
});
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

